import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css'; // 👈 Add this line for Ant Design v5+ styles
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();